import { removeUnsafe } from "./sessionReason.ts";

export const SESSION_NAME_PREFIX = "wylo-rc-session-name:";
const TITLE_CAP = 80;

export function sessionNameKey(deviceId: string): string {
  return `${SESSION_NAME_PREFIX}${deviceId}`;
}

export function titlePiece(value: string): string {
  const cleaned = removeUnsafe(value, false);
  return [...cleaned].slice(0, TITLE_CAP).join("").trim();
}

export function storedDeviceName(deviceId: string, name: string, hostname: string): string {
  return JSON.stringify({ deviceId, name, hostname });
}

export function readStoredDeviceName(raw: string | null, deviceId: string): { name: string; hostname: string } {
  if (!raw) return { name: "", hostname: "" };
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { name: "", hostname: "" };
  }
  if (!parsed || typeof parsed !== "object") return { name: "", hostname: "" };
  const record = parsed as Record<string, unknown>;
  if (record.deviceId !== deviceId) return { name: "", hostname: "" };
  return {
    name: typeof record.name === "string" ? record.name : "",
    hostname: typeof record.hostname === "string" ? record.hostname : "",
  };
}

export function deviceTitleName(device: { name?: string | null; hostname?: string | null } | null | undefined): string {
  const name = titlePiece(device?.name ?? "");
  if (name.length > 0) return name;
  const hostname = titlePiece(device?.hostname ?? "");
  if (hostname.length > 0) return hostname;
  return "Device";
}

export function sessionWindowTitle(name: string, kind: "remote" | "quality"): string {
  const label = titlePiece(name);
  const shown = label.length > 0 ? label : "Device";
  const suffix = kind === "remote" ? "Remote Session" : "Session Quality";
  return `${shown} - ${suffix}`;
}
